/* eslint-disable camelcase */
import { useSelector } from 'react-redux';
import { useFavoriteOrganisation } from 'hooks/useFavoriteOrganisation';
import { useReferenceCheckingAccount } from 'hooks/useReferenceCheckingAccount';
import { useListCreditCard } from 'hooks/useListCreditCard';

export const useAccountCategoryRef = ({
  financialAccountCat,
  amount,
  currency,
  rec_op_id,
}) => {
  const favoriteOrganisation = useFavoriteOrganisation();
  const referenceCheckingAccount = useReferenceCheckingAccount();
  const creditCardOptions = useListCreditCard();
  const persons = useSelector((state) => state.personalInfo.data);

  // For receivable and payable, combine persons and favourite organisations
  if (['receive', 'payable'].includes(financialAccountCat)) {
    const personOptions = persons.map(({ id, first_name, last_name }) => ({
      id: `P_${id}`, // Prefix with P_ to identify persons
      name: `${first_name} ${last_name}`,
      type: 'person',
      originalId: id,
    }));

    const orgOptions = favoriteOrganisation.map((org) => ({
      id: `O_${org.id}`, // Prefix with O_ to identify organisations
      name: org.name,
      type: 'organisation',
      originalId: org.id,
    }));

    return [...personOptions, ...orgOptions];
  }

// For bank accounts, filter by currency if provided
if (financialAccountCat === 'bank') {
  const filteredAccounts = currency && currency !== 'EUR' 
    ? referenceCheckingAccount.filter(
        ({ currency: bankAccountCurrency }) => bankAccountCurrency === currency,
      )
    : referenceCheckingAccount; 

  const bankOptions = filteredAccounts.map(({ id, account_no, org_name }) => ({
    id: account_no, 
    name: `${account_no}`,
    // name: org_name ? `${org_name} - ${account_no}` : `${account_no}`,
    dbId: id,
  }));
  
  return bankOptions;
}


// For cash accounts, return a single option with the currency
if (financialAccountCat === 'cash') {
    return [
      {
        id: currency,
        // id: String(amount),
        name: `${currency}`,
      },
    ];
}


if (financialAccountCat === 'credit') {
    return creditCardOptions.map(({ id, personal_detail, number }) => ({
      id,
      name: `${number}`,
      // name: personal_detail
      //   ? `${personal_detail.first_name} - ${number}`
      //   : `${number}`,
    }));
  }

  return [];
};
